const enviroment = {
  MP_TOKEN: window.config.mpToken,
  BUGSNAG_KEY: window.config.bugsnagToken,
  BUGSNAG_VERSION: window.config.client_app_version,
  REPORT_SESSION_BEGAN: window.config.reportSessionBegan,
  SESSION_BEGAN_TIMER: window.config.sessionBeganTimer,
  REPORT_ADD_FUNDS_SCREEN: window.config.reportAddFundsScreen,
  BACKEND_VERSION: window.config.backendVersion,
  HOTJAR_ID: window.config.hotjarId,
  NEED_TRACKING_HOTJAR: window.config.needTrackingHotjar,
  VIDEO_READING_BONUS: window.config.videoReadingBonus,
  VIDEO_READING_PRICE: window.config.videoReadingPrice,
  LOGGER_ENDPOINT: window.config.mba_logger_endpoint,
  LOGGER_SECRET: window.config.mba_logger_secret
};

export default enviroment;
